module.exports = __webpack_public_path__ + "img/9788982735226.c1e32e43.jpg";